import { Component, OnInit } from '@angular/core';
import {GlobalService} from '../../../global.service';
import {EventsService} from '../../events.service';
import {AppSettings} from '../../../app.settings';
import {Title} from "@angular/platform-browser";


@Component({
  selector: 'app-huawei-egypt',
  templateUrl: './huawei-egypt.component.html',
  styleUrls: ['./huawei-egypt.component.css']
})
export class HuaweiEgyptComponent implements OnInit {
  language: any;
  langChosen: string = 'en';
  constructor(public eventService: EventsService, public globalService: GlobalService , private titleService:Title) {
    this.titleService.setTitle('huawei egypt')
    if (this.globalService.isBrwoser) {
      if (localStorage.getItem('language')) {
        this.language = require('./lang/' + localStorage.getItem('language') + '.json');
        this.langChosen = localStorage.getItem('language');
      } else {
        this.language = require('./lang/en.json');
      }
    }
  }

  ngOnInit() {
  }
  languageChange(value) {
    if (this.globalService.isBrwoser) {
      this.langChosen = value;
      this.language = require('./lang/' + value + '.json');
      this.globalService.language = value;
      localStorage.setItem('language', value);
    }
  }


}
